module.exports = __webpack_public_path__ + "img/bg2.8d4d7cf6.png";